import { render, staticRenderFns } from "./TableauResultatsEquipe.vue?vue&type=template&id=2675e5f0"
import script from "./TableauResultatsEquipe.vue?vue&type=script&lang=js"
export * from "./TableauResultatsEquipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports